<template>
	<div class="wrapper">
		<ShareHeader :openTarget="'class/detail?id=' + courseid" />
		<div id="topVideoWrapper" class="topVideoWrapper" ref="topVideoWrapper">
			<div class="playButton">
				<img src="@/assets/image/course/play.png" alt="">
				<WxOpenTag :extinfo="'class/detail?id=' + courseid"/>
			</div>
		</div>
		<div class="topFollowButtonWrapper">
			<div class="followButton">
				打开APP查看更多
				<WxOpenTag :extinfo="'class/detail?id=' + courseid"/>
			</div>
		</div>
		<div class="topTitleSection">
			<div class="mainTitle">{{courseData.title}}</div>
			<div class="topTaskSection">
				<span class="firstLessonText">课时{{firstLessonNumber}}</span>
				<span class="verticalLine"></span>
				<span class="firstLessonTitle">{{firstLesson}}</span>
			</div>
		</div>
		<div class="describeSection" :class="{expand: expanded}">
			<div class="title">课程介绍</div>
			<div class="describe" v-html="courseData.about"></div>
			<div class="toggleButton" v-show="!expanded" @click="handleExpand">展开全部</div>
		</div>
		<div class="catalogSection">
			<div class="title">课程目录</div>
			<div class="catalogItem" v-for="catalog of catalogList" :key="catalog.catalogid">
				<div class="catalogDot"></div>
				<div class="catalogTitle">{{`课时${catalog.number}： ${catalog.title}`}}</div>
			</div>
		</div>
		<div class="commentSection">
			<div class="commentTitleWrapper">
				<div class="title">全部评论</div>
			</div>
			<ElaborateCourseCommentSection v-for="comment of commentList" :sectionData="comment" :key="comment.id + comment.createdtime" />
		</div>
		<div class="followButton">
			打开APP查看更多
			<WxOpenTag :extinfo="'class/detail?id=' + courseid"/>
		</div>
	</div>
</template>

<script>
import utils from '@/utils/utils'
import WxShare from '@/utils/wxshare'
import ShareHeader from '@/components/HeadModule'
import WxOpenTag from '@/components/WxOpenTag'
import ElaborateCourseCommentSection from '../ElaborateCourseCommentSection'
export default {
	data(){
		return {
			courseid: this.$route.query.courseid,
			courseData: {},
			catalogList: [],
			commentList: [],
			expanded: false
		}
	},

	created() {
		this.$router.push({
			path: '/collegeCourseRedirect',
			query: {
				courseId: this.courseid,
			}
		})
	},

	mounted(){
		this.init()
	},
	computed: {
		firstLesson(){
			if(this.catalogList.length){
				return this.catalogList[0].title
			}else{
				return ''
			}
		},
		firstLessonNumber(){
			if(this.catalogList.length){
				return this.catalogList[0].number
			}else{
				return 1
			}
		}
	},
	methods: {
		init(){
			this.getCourseInfo()
			this.getCatalogList()
			this.getCommentList()
		},
		getCourseInfo(){
			this.$http.get('/edu/courseDetail', {
				params: {
					course_id: this.courseid
				}
			}).then(res => {
				if(res.code >= 0){
					this.courseData = res.data
					this.$refs.topVideoWrapper && (this.$refs.topVideoWrapper.style.backgroundImage = `url('${res.data.pic}')`)
					new WxShare().share({
						title: res.data.title,
						desc: utils.trimHtmlTag(res.data.about),
						link: window.location.href,
						imgUrl: res.data.pic
					})
				}
			})
		},
		getCatalogList(){
			this.$http.get('/edu/listChapter', {
				params: {
					course_id: this.courseid
				}
			}).then(res => {
				if(res.code >= 0){
					this.generateLessonList(res.data)
				}
			})
		},
		generateLessonList(catalogList){
			for(let i=0; i < catalogList.length && this.catalogList.length <= 4; i++){
				let cur = catalogList[i]
				if(cur && cur.chapter_type === 'lesson'){
					this.catalogList.push(cur)
				}else{
					this.generateLessonList(cur.child)
				}
			}
		},
		getCommentList(){
			this.$http.get('/edu/comment', {
				params: {
					course_id: this.courseid,
					type: 1,
					start: 0,
					limit: 4
				}
			}).then(res => {
				if(res.code >= 0){
					this.commentList = res.data
				}
			})
		},
		handleExpand(){
			this.expanded = true
		},
	},
	components: {
		ShareHeader: ShareHeader,
		ElaborateCourseCommentSection: ElaborateCourseCommentSection,
		WxOpenTag: WxOpenTag,
	}
}
</script>

<style scoped>
.wrapper{
	background-color: #f7f8f8;
}
.mainTitle{
	font-size: 20px;
	font-weight: 600;
	color: #1d2023;
	padding: 0 0 8px 0;
	margin: 0;
}
.title{
	font-size: 18px;
	font-weight: 600;
	color: #1d2023;
	padding: 0;
	margin: 0;
}
.icon{
	display: inline-block;
	width: 20px;
	margin-right: 2px;
	vertical-align: middle;
	flex-shrink: 0;
}
.icon > img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.coverImg{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.line{
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.verticalLine{
	display: block;
	width: 1px;
	background-color: rgba(0, 0, 0, 0.07);
	margin: 0 10px;
	flex-shrink: 0;
}
.topVideoWrapper{
	position: relative;
	padding-top: 190px;
	padding-top: calc(100% / 1.44 - 50);
	background: #d8d8d8 no-repeat;
	background-size: cover;
	background-position: center;
}
.playButton{
	position: absolute;
	width: 55px;
	height: 55px;
	top: 50%;
	left: 50%;
	margin-left: -25px;
	margin-top: -25px;
}
.playButton > img{
	width: 55px;
	height: 55px;
	object-fit: contain;
}
.topFollowButtonWrapper{
	overflow: hidden;
	background-color: #fff;
}
.followButton{
	position: relative;
	margin: 15px;
	padding: 8px;
	font-size: 16px;
	color: #fff;
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
	background-color: #e50120;
}
.topTitleSection{
	padding: 0 15px 10px 15px;
	color: #1d2023;
	background-color: #fff;
}
.topTaskSection{
	display: flex;
	flex-wrap: nowrap;
	padding: 10px 0;
	font-size: 16px;
	white-space: nowrap;
}
.firstLessonText{
	color: #f00;
	font-weight: 500;
}
.firstLessonTitle{
	overflow: hidden;
	text-overflow: ellipsis;
}

.describeSection{
	position: relative;
	min-height: 60px;
	max-height: 190px;
	margin-top: 10px;
	padding: 15px;
	overflow: hidden;
	font-size: 16px;
	color: #606972;
	background-color: #fff;
}
.expand{
	max-height: none;
}
.describe{
	margin: 8px 0;
}
.describe img{
	max-width: 100%;
	height: auto;
}

.describe >>> img {
	max-width: 100% !important;
	height: auto;
}

.toggleButton{
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 5px 0 10px 0;
	font-size: 16px;
	color: #f5a623;
	text-align: center;
	background-color: #fff;
	box-shadow: 0 -10px 10px #fff;
}

.catalogSection{
	margin-top: 10px;
	padding: 15px 15px 0 15px;
	background-color: #fff;
}
.catalogItem{
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	padding: 15px 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.catalogItem:last-child{
	border-bottom: none;
}
.catalogDot{
	width: 15px;
	height: 15px;
	background-image: url('../../../assets/image/course/chapter_dot.png');
	background-repeat: no-repeat;
	background-size: contain;
}
.catalogTitle{
	flex: 1;
	margin-left: 10px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.courseItem{
	width: 48%;
	margin: 6px 0;
}
.coverWrapper{
	width: 100%;
	height: 103px;
	border-radius: 5px;
	overflow: hidden;
	background-color: #eee;
}
.courseTitle{
	height: 40px;
	margin-top: 5px;
	font-size: 14px;
	line-height: 20px;
	color: #1d2023;
	overflow: hidden;
	text-overflow: ellipsis;
	line-clamp: 2;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
}
.commentSection{
	margin-top: 10px;
	background-color: #fff;
}
.commentTitleWrapper{
	padding: 15px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.commentTitleWrapper:last-child, .commentSection .itemWrapper:last-child{
	border-bottom: none;
}
</style>